import React, { Component, Fragment } from "react";
import Form from "react-bootstrap/lib/Form";
import { FieldArray } from "formik";
import map from "lodash.map";
import moment from "moment";
import { ConsultationCategoryContainer } from "./ConsultationCategoryContainer";
import { ProjectType } from "../../../utils/enums";
import { Attachment } from "../../Attachment";

export class OneFormConsultationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: props.isOnlyOneConsultationForms,
    };

    this.toggleOpen = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        opened: !this.state.opened,
      });
    };
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.isOnlyOneConsultationForms !==
      this.props.isOnlyOneConsultationForms
    ) {
      this.setState({
        opened: this.props.isOnlyOneConsultationForms,
      });
    }
  }

  renderAttachmentsIcon(type) {
    switch (type) {
      case "application/pdf": {
        return (
          <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
      default: {
        return (
          <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
    }
  }

  renderProject() {
    let {
      prefixName,
      type,
      disabled,
      isResultPublished,
      voted,
      outOfRangeVoteDates,
      outOfRangeDistricts,
      index,
      attachments,
      resultAttachments,
      loggedUserId,
      projectType,
      isAuth,
      availableVoteNotLogged,
      onChange,
      onBlur,
      setFieldValue,
      errors,
      categories,
    } = this.props;

    return (
      <Fragment>
        {errors && typeof errors.maxPoint === "string" && (
          <Form.Control.Feedback
            type="invalid"
            style={{ display: "block", color: "red", marginTop: 10 }}
          >
            {errors.maxPoint}
          </Form.Control.Feedback>
        )}
        <FieldArray
          id={`${prefixName}categories`}
          name={`${prefixName}categories`}
          render={(_) => (
            <ConsultationCategoryContainer
              items={categories}
              consultationFormType={type}
              disabled={
                disabled ||
                isResultPublished ||
                voted ||
                outOfRangeVoteDates ||
                outOfRangeDistricts
              }
              prefixName={`consultationForms.${index}.`}
              isResultPublished={isResultPublished}
              loggedUserId={loggedUserId}
              isAuth={isAuth}
              availableVoteNotLogged={availableVoteNotLogged}
              projectType={projectType}
              onChange={onChange}
              onBlur={onBlur}
              setFieldValue={setFieldValue}
              errors={errors}
              isPreview={this.props.isPreview}
            />
          )}
        />
        {attachments && attachments.length > 0 && (
          <React.Fragment>
            <div className="consultations__title margin-top-25 margin-bottom-15">
              Załączniki
            </div>
            <div className="attachments-list">
              {map(attachments, (attachment) => (
                <Attachment
                  key={attachment.id}
                  {...{
                    attachment,
                    url: attachment.isAct
                      ? `/api/actAttachments/${attachment.id}`
                      : `/api/attachments/${attachment.id}`,
                  }}
                >
                  {this.renderAttachmentsIcon(attachment.contentType)}
                </Attachment>
              ))}
            </div>
          </React.Fragment>
        )}
        {resultAttachments && resultAttachments.length > 0 && (
          <React.Fragment>
            <div className="consultations__title margin-top-25 margin-bottom-15">
              Załączniki
            </div>
            <div className="attachments-list">
              {map(resultAttachments, (attachment) => (
                <Attachment
                  key={attachment.id}
                  {...{
                    attachment,
                    url: attachment.isAct
                      ? `/api/actAttachments/${attachment.id}`
                      : `/api/attachments/${attachment.id}`,
                  }}
                >
                  {this.renderAttachmentsIcon(attachment.contentType)}
                </Attachment>
              ))}
            </div>
          </React.Fragment>
        )}
      </Fragment>
    );
  }

  render() {
    let {
      district,
      maxPoint = 0,
      categoryMaxPoint = 0,
      questionMaxPoint = 0,
    } = this.props;
    let { opened } = this.state;

    let points = {
      maxForDistrict: maxPoint,
      maxForCategory: categoryMaxPoint,
      maxForProject: questionMaxPoint,
    };

    return (
      <React.Fragment>
        {this.props.projectType === ProjectType.PublicBudget && (
          <Fragment>
            <div className="consultations__item">
              <div className="consultations__body">
                <div className="consultations__item consultations__item--no-margins consultations__item--no-padding">
                  <div
                    className="consultations__header"
                    onClick={this.toggleOpen}
                  >
                    <div className="consultations__title consultations__title--center">
                      {district ? district.name : "Ogólnomiejski"}
                    </div>
                    <div className="consultations__icons">
                      <div
                        className="consultations__switch consultations__switch--primary-dark"
                        onClick={this.toggleOpen}
                      >
                        {opened ? "Zwiń" : "Rozwiń"}
                        {
                          <i
                            className={`consultations__icon fas fa-angle-${
                              opened ? "up" : "down"
                            }`}
                          />
                        }
                      </div>
                    </div>
                  </div>

                  {opened &&
                    this.props.projectType === ProjectType.PublicBudget && (
                      <div className="consultations__subtitle consultations__subtitle--center">
                        <i>
                          Zasady przyznawania punktów: maksimum na obszar{" "}
                          {points.maxForDistrict} pkt, na kategorię{" "}
                          {points.maxForCategory} pkt, na projekt{" "}
                          {points.maxForProject} pkt.
                        </i>
                      </div>
                    )}

                  {opened && (
                    <div className="consultations__body">
                      <div className="consultations__item">
                        {this.renderProject()}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Fragment>
        )}
        {this.props.projectType !== ProjectType.PublicBudget &&
          this.renderProject()}
      </React.Fragment>
    );
  }
}

OneFormConsultationForm.defaultProps = {
  categoryPointDivision: false,
  disabled: false,
  id: 0,
  index: 0,
  isResultPublished: false,
  loggedUserId: 0,
  maxPoint: 0,
  outOfRangeVoteDates: false,
  outOfRangeDistricts: false,
  prefixName: "",
  projectType: 0,
  publishType: -1,
  rowId: 0,
  shortDescription: "",
  status: -1,
  statusName: "",
  type: 0,
  voted: false,
  voteFrom: moment().format("YYYY-MM-DD"),
  voteTo: moment().format("YYYY-MM-DD"),
  agreementAcceptedRequired: false,

  answers: [],
  attachments: [],
  categories: [],
};
